import type { AnnotationStatus } from '@rossum/api-client/shared';
import { snakeToCamel } from '@rossum/api-client/utils';
import type { LocalizationKeys } from '../../../../i18n';
import { snakeCaseStatuses } from '../../../../types/annotationStatus';

const isAnnotationStatus = (value: string): value is AnnotationStatus =>
  snakeCaseStatuses.some(status => status === value);

export const toDisplayedStatus = (status: string | null) =>
  status && isAnnotationStatus(status) && status !== 'purged'
    ? snakeToCamel(status)
    : null;

export const getStatusLabelId = (
  status: NonNullable<ReturnType<typeof toDisplayedStatus>>
): LocalizationKeys => `containers.annotationList.statuses.${status}`;
